module.exports = __webpack_public_path__ + "static/img/template-icon.f7693a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chat/template-icon.png
// module id = krf1
// module chunks = 1